export const Roles = {
  admin: 'admin',
  user: 'user',
}
